<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">
        <span>{{ $t('folder_show.activities.subscribe_to_folder_bulk') }}</span>
      </h5>
    </template>

    <template #body>
      <form @submit.prevent='submit'>
        <div class='modal-body text-left'>
          <p>{{ $t('folder_show.activities.subscribe_updates') }}:</p>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.event_groups.file_uploads') }}
            <input type="checkbox" name="event_subscriptions[event_group][]" value="file_uploads" v-model='eventSubs'>
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.event_groups.file_removal') }}
            <input type="checkbox" name="event_subscriptions[event_group][]" value="file_removal" v-model='eventSubs'>
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.event_groups.file_replacements') }}
            <input type="checkbox" name="event_subscriptions[event_group][]" value="file_replacements" v-model='eventSubs'>
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.notify_via') }}:</p>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_email') }}
            <input type="checkbox" name="event_subscriptions[activity_notify_via][]" value="email" v-model='notificationMedium'>
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_app') }}
            <input type="checkbox" name="event_subscriptions[activity_notify_via][]" value="app" v-model='notificationMedium'>
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.frequency_days') }}:</p>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_immediately') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="0" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_weekly') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="7" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.bi_weekly') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="14" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.monthly') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="30" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary float-right" :disabled='!canSubmit || isProcessing'>
            {{$t('folder_show.activities.subscribe')}}
            <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
          </button>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        folderIds: [],
        isProcessing: false,
        eventSubs: [],
        notificationInterval: null,
        notificationMedium: [],
      }
    },
    computed: {
      canSubmit() {
        return this.eventSubs.length > 0 && this.notificationMedium.length > 0 && this.notificationInterval
      },
    },
    methods: {
      open(folders) {
        this.folderIds = (folders || []).map(f => f.id)

        this.eventSubs = []
        this.notificationMedium = []
        this.notificationInterval = null

        this.$refs.modal.open()
      },
      submit(e) {
        this.isProcessing = true

        const params = new FormData(e.target)
        const promises = this.folderIds.map(id => this.store.createFolderSubscription(id, params))

        Promise.allSettled(promises).then(() => {
          this.store.sendMetrics({name: 'share_folder_subscribe', params: this.$route.params, path: this.$route.fullPath})
          this.$toastr.success(this.$t('folder_show.activities.successfully_subscribed'))
          this.$emit('success')
        }).finally(() => {
           this.isProcessing = false
           e.target.reset()
           this.$refs.modal.close()
        }).catch(() => {
           this.isProcessing = false
           this.$refs.modal.close()
        })

      },
    }
  }
</script>
